import React from 'react';

export function Loader() {
    return (
        <div className='bytel-loader'>
            <span />
        </div>
    );
}
